export default __webpack_public_path__ + "static/media/7minfitness_11.4bd03671.jpg";